import {
  PhoneIcon,
  MailIcon,
  LocationMarkerIcon,
  ChevronRightIcon,
  UserCircleIcon,
  LinkIcon,
} from "@heroicons/react/solid";
import React, {useEffect, useState} from "react";
import LinkedinLogo from "../../assets/images/linkedin_logo_black.svg";
import GithubLogo from "../../assets/images/github_logo.svg";
import Image from "next/image";

import { useForm } from "react-hook-form";
import axios from "axios";
import toast, { Toaster } from 'react-hot-toast';

export default function ApplyNowForm() {

  const { register, setError, formState: { errors }, handleSubmit, reset } = useForm();
  const [ loading, setLoading ] = useState(false);
  const [ jobPositions, setJobPositions ] = useState<any>([]);

  const onSubmit = async (data: any) => {
        
    setLoading(true);
    const file = data.resume[0];

    var allowedExtensions = /(\.doc|\.docx|\.pdf)$/i;
             
    if (!allowedExtensions.exec(file.name)) {
      setError("resume", {
        type: "filetype"
      });
      setLoading(false);
      return;
    }

    if ((file.size/1024/1024) > 2) {
      setError("resume", {
        type: "filesize"
      });
      setLoading(false);
      return;
    }

    const _window: any = window;
    const { grecaptcha } = _window;
    grecaptcha.ready(() => {
      grecaptcha.execute(process.env.recaptcha_site_key, {action: 'submit'}).then(async (token: string) => {
        try {
      
          let formData = new FormData();

          data.g_recaptcha_token = token;

          const filename = 'file_' + String(Date.now());
          formData.append("files.resume", file, filename);
          formData.append("data", JSON.stringify(data));

          const result = await fetch(`${process.env.admin_url}/api/join-applications`, {
            method: 'post',
            body: formData
          });

          if (result.status === 200) {
            toast.success('Successfully submitted .');
            handleResetForm();
          } else {
            toast.error('Something went wrong. Please try again later.');
          }
          setLoading(false);
        } catch (e: any) {
          if (e?.response?.data?.error?.details?.error == 'google-recaptcha-error') {
            toast.error(e?.response?.data?.error?.message);
          } else {
            toast.error('Something went wrong. Please try again later.');
          }
          setLoading(false);
        }
      });
    });
  }

  const handleResetForm = () => {
    reset({
      name: '',
      address: '',
      email: '',
      phone: '',
      applying_for: '',
      resume: '',
      linkedin: '',
      github: '',
    });
  }

  const fetchJobPositions = async () => {
    try {
      const result = await axios.get(`${process.env.admin_url}/api/job-positions`);

      setJobPositions(result?.data?.data);
    } catch (e) {
      console.log(e);
    }
  }

  useEffect( () => { fetchJobPositions(); }, []);

  return (
    <div>
      <Toaster
          position="bottom-center"
          reverseOrder={false}
      />
      <div className="font-bold lg:flex justify-between w-full">
        <div className="text-[2.5rem] md:px-0 px-8">
          <h1 className="md:text-header text-header-mbl font-sourcesans flex relative">
            <span className="after:content-[''] after:absolute after:w-24 md:after:w-32 after:h-0 md:after:h-1 after:bottom-[-16px] after:left-0 after:border-4 md:after:border-4 after:border-secondary-500 after:rounded">
                Open<span className='text-orange'> Position </span>
            </span>
          </h1>

            <div className="border-collapse	mt-20 border-l-2 border-l-orange">
              {jobPositions.map((item: any)=>{
                return(
                  <div key={item.id} className="text-h3 md:text-sub-header py-4 flex items-center gap-6 ml-[-9px]">
                    <svg width="15" height="15" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="10" cy="10" r="10" fill="#F36012"/>
                    </svg>
                    {item?.attributes?.title}
                  </div>
                )
              })}

            </div>
        </div>


        <form action="#" method="POST" onSubmit={handleSubmit(onSubmit)} className="max-w-[850px] rounded-2xl border-[#cccccc] border p-10 mt-10 lg:mt-auto relative">
          <div className="overlay rounded-3xl" style={{ display: loading ? 'block' : 'none' }}>
            <div className="loader">
              <div className="inner one"></div>
              <div className="inner two"></div>
              <div className="inner three"></div>
            </div>
          </div>
          <h3 className="text-2xl opacity-80 text-primary-500 font-montserratB mb-10">Apply Now!!!</h3>
          <div className="col-span-6 mb-6">
            <label
              htmlFor="first-name"
              className="text-h3 font-montserratB text-primary-500 opacity-80"
            >
              Name
            </label>
            <div className="mt-4 relative rounded-md shadow-sm ">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <UserCircleIcon
                  className="h-5 w-5 text-primary-500"
                  aria-hidden="true"
                />
              </div>
              <input
                type="text"
                className="appearance-none min-w-0 w-full bg-white border border-gray-600 rounded-md shadow-sm py-2 pl-10 px-4 text-base text-gray-900 placeholder-gray-900 focus:outline-none focus:ring-green-500 focus:border-green-500 focus:placeholder-gray-400"
                placeholder="Type here.."
                {...register("name", { required: true })}
                aria-invalid={errors.name ? "true" : "false"}
                required
              />
            </div>
            {errors.name?.type === 'required' && <p className="formError">Name is required</p>}
          </div>


          <div className="grid grid-cols-6 gap-6 mb-6">
            <div className="col-span-6 sm:col-span-3">
              <label
                htmlFor="last-name"
                className="text-h3 font-montserratB text-primary-500 opacity-80"
              >
                Email
              </label>
              <div className="mt-4 relative rounded-md shadow-sm ">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <MailIcon
                    className="h-5 w-5 text-primary-500"
                    aria-hidden="true"
                  />
                </div>
                <input
                  type="email"
                  className="appearance-none min-w-0 w-full bg-white border border-gray-600 rounded-md shadow-sm py-2 pl-10 px-4 text-base text-gray-900 placeholder-gray-900 focus:outline-none focus:ring-green-500 focus:border-green-500 focus:placeholder-gray-400"
                  placeholder="Type here.."
                  {...register("email", { required: true })}
                  aria-invalid={errors.email ? "true" : "false"}
                  required
                />
              </div>
              {errors.email?.type === 'required' && <p className="formError">Email is required</p>}
            </div>
            <div className="col-span-6 sm:col-span-3">
            <label
              htmlFor="street-address"
              className="text-h3 font-montserratB text-primary-500 opacity-80"
            >
              Address
            </label>
            <div className="mt-4 relative rounded-md shadow-sm">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <LocationMarkerIcon
                  className="h-5 w-5 text-primary-500"
                  aria-hidden="true"
                />
              </div>
              <input
                type="text"
                className="appearance-none min-w-0 w-full bg-white border border-gray-600 rounded-md shadow-sm py-2 pl-10 px-4 text-base text-gray-900 placeholder-gray-900 focus:outline-none focus:ring-green-500 focus:border-green-500 focus:placeholder-gray-400"
                placeholder="Type here.."
                {...register("address", { required: true })}
                aria-invalid={errors.address ? "true" : "false"}
                required
              />
            </div>
              {errors.address?.type === 'required' && <p className="formError">Address is required</p>}
            </div>
          </div>

          <div className="grid grid-cols-6 gap-6 mb-6">
            <div className="col-span-6 sm:col-span-3">
              <label
                htmlFor="first-name"
                className="text-h3 font-montserratB text-primary-500 opacity-80"
              >
                Phone No
              </label>
              <div className="mt-4 relative rounded-md shadow-sm">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <PhoneIcon
                    className="h-5 w-5 text-primary-500"
                    aria-hidden="true"
                  />
                </div>
                <input
                  type="tel"
                  className="appearance-none min-w-0 w-full bg-white border border-gray-600 pl-10 rounded-md shadow-sm py-2 px-4 text-base text-gray-900 placeholder-gray-900 focus:outline-none focus:ring-green-500 focus:border-green-500 focus:placeholder-gray-400"
                  placeholder="Type here.."
                  {...register("phone", { required: true })}
                  aria-invalid={errors.phone ? "true" : "false"}
                  required
                />
              </div>
              {errors.phone?.type === 'required' && <p className="formError">Phone no is required</p>}
            </div>

            <div className="col-span-6 sm:col-span-3">
              <label
                htmlFor="apply"
                className="text-h3 font-montserratB text-primary-500 opacity-80"
              >
                Applying For
              </label>
              <div className="mt-4 relative rounded-md shadow-sm ">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <UserCircleIcon
                    className="h-5 w-5 text-primary-500"
                    aria-hidden="true"
                  />
                </div>
                <input
                  type="text"
                  className="appearance-none min-w-0 w-full bg-white border border-gray-600 rounded-md shadow-sm py-2 pl-10 px-4 text-base text-gray-900 placeholder-gray-900 focus:outline-none focus:ring-green-500 focus:border-green-500 focus:placeholder-gray-400"
                  placeholder="Type here.."
                  {...register("applying_for", { required: true })}
                  aria-invalid={errors.applying_for ? "true" : "false"}
                  required
                />
              </div>
              {errors.applying_for?.type === 'required' && <p className="formError">Applying for is required</p>}
            </div>
          </div>


          <div className="col-span-6 mb-6">
            <label
              htmlFor="cv"
              className="text-h3 font-montserratB text-primary-500 opacity-80"
            >
              CV/Resume
            </label>
            <div className="mt-4 relative rounded-md shadow-sm">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <LinkIcon
                  className="h-5 w-5 text-primary-500"
                  aria-hidden="true"
                />
              </div>
              <input
                type="file"
                className="appearance-none min-w-0 w-full bg-white border border-gray-600 pl-10 rounded-md shadow-sm py-2 px-4 text-base text-gray-900 placeholder-gray-900 focus:outline-none focus:ring-green-500 focus:border-green-500 focus:placeholder-gray-400"
                placeholder="Type here.."
                {...register("resume", { required: true })}
                aria-invalid={errors.resume ? "true" : "false"}
                required
                accept=".pdf,.doc,.docx"
              />
            </div>
            {errors.resume?.type === 'required' && <p className="formError">Resume is required</p>}
            {errors.resume?.type === 'filetype' && <p className="formError">Only PDFs and Docs are valid</p>}
            {errors.resume?.type === 'filesize' && <p className="formError">File size exceeds 2 MiB</p>}
          </div>


          <div className="grid grid-cols-6 gap-6 mb-6">
            <div className="col-span-3">
              <label
                htmlFor="linkedin"
                className="text-h3 font-montserratB text-primary-500 opacity-80"
              >
                Linkedin Profile
              </label>
              <div className="mt-4 relative rounded-md shadow-sm">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <Image  src={LinkedinLogo} alt=''/>
                </div>
                <input
                  type="text"
                  className="appearance-none min-w-0 w-full bg-white border border-gray-600 rounded-md shadow-sm py-2 pl-12 px-4 text-base text-gray-900 placeholder-gray-900 focus:outline-none focus:ring-green-500 focus:border-green-500 focus:placeholder-gray-400"
                  placeholder="Link here.."
                  {...register("linkedin", { required: true })}
                  aria-invalid={errors.linkedin ? "true" : "false"}
                  required
                />
              </div>
              {errors.linkedin?.type === 'required' && <p className="formError">Linkedin profile is required</p>}
            </div>
            <div className="col-span-3">
              <label
                htmlFor="github"
                className="text-h3 font-montserratB text-primary-500 opacity-80"
              >
                Github Profile
              </label>
              <div className="mt-4 relative rounded-md shadow-sm">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <Image  src={GithubLogo} alt=''/>
                </div>
                <input
                  type="text"
                  className="appearance-none min-w-0 w-full bg-white border border-gray-600 rounded-md shadow-sm py-2 pl-10 px-4 text-base text-gray-900 placeholder-gray-900 focus:outline-none focus:ring-green-500 focus:border-green-500 focus:placeholder-gray-400"
                  placeholder="Link here.."
                  {...register("github", { required: true })}
                  aria-invalid={errors.github ? "true" : "false"}
                />
              </div>
              {errors.github?.type === 'required' && <p className="formError">Github profile is required</p>}
            </div>
          </div>

          <div className="flex justify-start flex-wrap gap-4 mt-16">
              <button type="submit"
                      disabled={loading}
                      className="inline-flex z-10 items-center text-h3 font-montserratB px-16 py-3 rounded-full bg-btn-gradient text-white hover:border-primary-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500  mt-4">
                {loading ? 'Submitting...' : 'SUBMIT'}
              </button>

              <button type="button"
                      onClick={handleResetForm}
                  className="inline-flex z-10 items-center text-h3 font-montserratB px-16 py-3 rounded-full hover:color-white border-2 border-primary-600 text-primary-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 mt-4 ">
                  RESET
              </button>
          </div>
        </form>
      </div>
    </div>
  );
}
